import React, { useEffect, useState, useRef } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';

import Loader from './Loader/Loader';
import useMediaUpload from '../hooks/useMediaUpload';
import DeleteConfirmationPopup from './DeleteConfirmationPopup';

import search from "../assets/images/icon-search.svg";
import deleteIcon from '../assets/images/delete.svg'
import { deleteMedia } from '../api/mediaApi';


const UploadedPopupMedia = ({ setUserMedia, userMedia, selectedItems, setSelectedItems, isLoading, setShowUploadMediaPopup, setSelectedProfileImage, uploadMediaPopupFor, fetchMoreData, hasUserScrolled, isFetchingMore, hasMore, InfiniteLoader, searchInput, setSearchInput }) => {

    const [deleteConfirmation, setDeleteConfirmation] = useState(false);
    const [isDelLoading, setDelIsLoading] = useState(false);
    const [isImageDragging, setIsImageDragging] = useState(false);
    const [previewMeida, setPreviewMeida] = useState('');
    const [selectedItemData, setSelectedItemData] = useState([]);
    const deletePopupRef = useRef();
    const fileInputRef = useRef(null);

    const [fileList, setFileList] = useState({
        '^image/': 'Images',
        '^video/': 'Videos',
        'application/pdf': 'PDF',
        'application/doc': 'DOC',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCX',
        'application/vnd.ms-powerpoint': 'PPT',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'PPTX',
        'application/vnd.ms-powerpoint.presentation.macroenabled.12': 'PPTM',
        'application/vnd.ms-excel': 'XLS',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'XLSX',
        'application/vnd.ms-excel.sheet.macroenabled.12': 'XLSM'
    });

    const { handleMeidaUpload } = useMediaUpload(setUserMedia, null, fileList);

    useEffect(() => {
        if (deleteConfirmation) {
            const checkIfClickedOutside = (e) => {
                if (e.target != null && deleteConfirmation && deletePopupRef.current && !deletePopupRef.current.contains(e.target)) {
                    setDeleteConfirmation(false);
                }
            };
            document.addEventListener("mousedown", checkIfClickedOutside);

            return () => {
                document.removeEventListener("mousedown", checkIfClickedOutside);
            };
        }
    }, [deleteConfirmation]);

    const confirmDelete = async () => {
        try {
            setDelIsLoading(true);

            await deleteMedia(selectedItems);

            const updatedDisplayMedia = userMedia.filter(media => !selectedItems.includes(media.id));
            setUserMedia(updatedDisplayMedia);
            setSelectedItems([])

            setDelIsLoading(false);
            setDeleteConfirmation(false);

        } catch (error) {
            setDelIsLoading(false);
            console.log(error)
        }
    };

    useEffect(() => {
        if (uploadMediaPopupFor === 'video-file') {
            setFileList({
                '^video/': 'Videos',
            });
        } else if (uploadMediaPopupFor === 'docfiles-selection') {
            setFileList({
                'application/pdf': 'PDF',
                'application/doc': 'DOC',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCX',
                'application/vnd.ms-powerpoint': 'PPT',
                'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'PPTX',
                'application/vnd.ms-powerpoint.presentation.macroenabled.12': 'PPTM',
                'application/vnd.ms-excel': 'XLS',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'XLSX',
                'application/vnd.ms-excel.sheet.macroenabled.12': 'XLSM'
            });
        } else {
            setFileList({
                '^image/': 'Images',
            });
        }
    }, [uploadMediaPopupFor]);

    const handleCheckboxChange = (itemId) => {
        setSelectedItems((prevSelectedItems) => {
            if (!prevSelectedItems.includes(itemId)) {
                if (uploadMediaPopupFor === 'images-file') {
                    return [itemId, ...prevSelectedItems];
                } else {
                    return [itemId];
                }
            }
            return prevSelectedItems; // No removal logic
        });

        const selectedMediaObject = userMedia.find(item => item.id === itemId);
        setPreviewMeida(selectedMediaObject);
        setSelectedItemData([...selectedItemData, selectedMediaObject])
    };

    const handleUnCheckboxChange = (itemId) => {
        let updatedSelectedItems;
        if (selectedItems?.includes(itemId)) {
            updatedSelectedItems = selectedItems?.filter((id) => id !== itemId);
            setPreviewMeida(null);
        } else {
            if (uploadMediaPopupFor === 'images-file') {
                updatedSelectedItems = [itemId, ...selectedItems];
            } else {
                updatedSelectedItems = [itemId];
            }
            const selectedMediaObject = userMedia?.find(item => item.id === itemId);
            setPreviewMeida(selectedMediaObject);
        }
        setSelectedItems(updatedSelectedItems);
    };

    const handleFileDragOver = (e) => {
        e.preventDefault();
        setIsImageDragging(true);
    }

    const handleFileDragLeave = (e) => {
        e.preventDefault();
        setIsImageDragging(false);
    };

    const handleFileDrop = async (e) => {
        e.preventDefault();

        const files = e.dataTransfer.files;
        await handleMeidaUpload(files);

        setIsImageDragging(false);
    };

    return (
        <div className={isImageDragging ? `draging poppContentWrapper` : `poppContentWrapper`} onDragOver={handleFileDragOver} onDragLeave={handleFileDragLeave} onDrop={handleFileDrop}>
            <input type="file" ref={fileInputRef} id="pulication-file" multiple hidden />
            <div className={`grid-container media-grid-layout ${(previewMeida) && 'rshow-wrappe'}`} id="media-scroll-container">
                <div className="mediaSearch">
                    <div className="mediaSearchTop">
                        <div className="mediaSearchInput">
                            <input type="text" name="pages_search" id="pages_search" className="inputFields" placeholder="Search" onChange={(e) => setSearchInput(e.target.value)} value={searchInput} />
                            <img src={search} alt="Search" className='mediaSearchIcon' />
                        </div>
                        <button className='add-btn' disabled={!previewMeida} onClick={() => { setSelectedProfileImage(selectedItemData); setShowUploadMediaPopup(false); }}>
                            Select Image
                        </button>
                    </div>
                    {(selectedItems && selectedItems.length > 0) && (
                        <div className="mediasSearchIcon a">
                            <div className='deleteIcon' onClick={() => { setDeleteConfirmation(true) }}>
                                <img className='deleteIconImage' src={deleteIcon} alt="Clear Input" />
                            </div>
                        </div>
                    )}
                </div>
                <InfiniteScroll
                    dataLength={userMedia?.length || 0}
                    next={fetchMoreData}
                    hasMore={hasMore}
                    loader={
                        hasUserScrolled && isFetchingMore ? <InfiniteLoader /> : null
                    }
                    scrollableTarget="media-scroll-container"
                    scrollThreshold={0.9}
                >
                    {isLoading ?
                        <div className="loader-container">
                            <div className="loader"></div>
                        </div>
                        :
                        <>
                            {/* {(userMedia && userMedia.length > 0) ? */}
                            <div className="gridIitem">
                                {userMedia?.map((media) => (
                                    <div className={`gridImg ${(previewMeida && previewMeida.id === media.id) && 'preview-acive'} ${(media.type).includes('image') ? 'type-image' : 'type-doc'} ${selectedItems.includes(media.id) ? 'selected' : ''}`} onClick={() => handleCheckboxChange(media.id)} key={media.id}>
                                        {media?.isLoading ?
                                            <div className="uploadPicture">
                                                <Loader />
                                            </div>
                                            :
                                            <>
                                                <img src={media?.url} alt={media.name} className='item' />

                                                {(!(media.type).includes('image')) && <div className='itemName'> {media.name} </div>}

                                                <input type="checkbox" checked={selectedItems.includes(media.id)} onChange={() => { handleUnCheckboxChange(media?.id) }} />
                                            </>
                                        }
                                    </div>
                                ))}
                            </div>
                            {/* :
                            <NoResults type="media-gallery" name="Media Library" mediaPopup='popup' onclickhandle={() => setUploadNewmedia(!uploadNewmedia)} status="all" /> */}
                            {/* } */}
                        </>
                    }
                </InfiniteScroll>

                <DeleteConfirmationPopup
                    showDeletePopup={deleteConfirmation}
                    reference={deletePopupRef}
                    confirmDelete={confirmDelete}
                    setShowDeletePopup={setDeleteConfirmation}
                    onCancel={() => setDeleteConfirmation(false)}
                    isLoading={isDelLoading}
                    title={'Media'}
                    description={`Are you sure you want to delete media? This action cannot be undone.`}
                />

            </div>
        </div>
    );
};


export default UploadedPopupMedia;